/**
 * used to check the compare selected filterValues
 * @param selectedFilters
 * @returns [[dateRange selection values],[other filter selection values]]
 */
export const filterValues: any = (
  selectedFilters: any,
  isCustomised = false,
) => {
  const filterValues: any = []
  for (const { value, dateRange, dateRangeOption } of selectedFilters) {
    if (value || dateRange) {
      filterValues.push(
        value || [
          isCustomised && dateRangeOption !== 'custom'
            ? dateRangeOption
            : dateRange,
        ],
      )
    }
  }

  return filterValues
}

export const filterUpdatesForJSONCheck = (filterValues: any) =>
  filterValues
    ?.map((item: any) => {
      return item?.[0] &&
        typeof item?.[0] !== 'string' &&
        !Object.keys(item?.[0]).includes('startDate')
        ? item
            ?.sort((x: any, y: any) => x?.id - y?.id)
            .map((item: any) => {
              return { id: item?.id }
            })
        : item
    })
    .filter((n: any) => n.length)
